import { render, staticRenderFns } from "./SaveClose.vue?vue&type=template&id=73acd33e"
import script from "./SaveClose.vue?vue&type=script&lang=js"
export * from "./SaveClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports